export function normaliseURL(url) {
  if (!url) {
    url = document.URL
  }
  if (!url) {
    url = ''
  }
  return url.toLowerCase()
}
